(() => {
  const updatePlans = (coverage) => {
    const plans = document.getElementById('longTermPlans');
    if (!plans) return;
    let count = 0;
    plans.querySelectorAll('[data-plan-coverage]').forEach((card) => {
      card.hidden = Boolean(coverage && card.dataset.planCoverage !== coverage);
      if (!card.hidden) count += 1;
    });
    plans.style.setProperty('--csim-visible-plans', String(Math.max(count, 1)));
  };

  const selectedCoverage = (calendar) => {
    const input = calendar?.querySelector('[data-plan-filter-usage-input]');
    return ['canada-only', 'canada-usa'].includes(input?.value) ? input.value : '';
  };

  const syncPlans = () => {
    const calendar = document.querySelector('plan-filter-calendar');
    updatePlans(selectedCoverage(calendar));
  };

  const initialCoverage = new URLSearchParams(location.search).get('plan_filter_usage');
  updatePlans(['canada-only', 'canada-usa'].includes(initialCoverage) ? initialCoverage : '');

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const option = event.target.closest('[data-plan-filter-usage-option]');
    if (option) {
      updatePlans(option.dataset.planFilterUsageOption);
      return;
    }

    const findButton = event.target.closest('[data-plan-filter-find-button]');
    const plans = document.getElementById('longTermPlans');
    if (!findButton || findButton.disabled || !plans) return;
    const calendar = findButton.closest('plan-filter-calendar');
    const coverage = selectedCoverage(calendar);
    if (!coverage) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updatePlans(coverage);
    const url = new URL(location.href);
    const fields = {
      plan_filter_start: '[data-plan-filter-start-input]',
      plan_filter_end: '[data-plan-filter-end-input]',
      plan_filter_mode: '[data-plan-filter-mode-input]',
      plan_filter_usage: '[data-plan-filter-usage-input]'
    };
    Object.entries(fields).forEach(([key, selector]) => {
      const value = calendar.querySelector(selector)?.value;
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    });
    url.hash = 'longTermPlans';
    history.replaceState(null, '', url);
    plans.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target instanceof Element && event.target.closest('[data-plan-filter-apply]')) syncPlans();
  });

  document.addEventListener('shopify:section:load', syncPlans);
})();
